import { Card, Image, Text, Badge, Group, Stack, AspectRatio } from "@mantine/core";
import { Product } from "../../services/productService";
import { Link } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_BASE_URL || 'https://thalvora-exports.onrender.com';

const getImageUrl = (url?: string) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  const normalized = url.startsWith("/") ? url : `/${url}`;
  return `${API_URL}${normalized}`;
};

export const ProductCard = ({ product }: { product: Product }) => {
  const imageUrl = getImageUrl(product.images?.[0]);

  return (
    <Card
      withBorder
      radius="lg"
      shadow="sm"
      component={Link}
      to={`/products/${product.slug}`}
      style={{ textDecoration: "none", color: "inherit" }}
      padding="lg"
    >
      {/* Fixed aspect ratio container */}
      <AspectRatio ratio={4 / 3} mx="auto">
        <Image
          src={imageUrl}
          alt={product.name}
          fit="cover"  // This ensures image covers the area without distortion
          fallbackSrc="https://via.placeholder.com/400x300?text=No+Image"
          radius="md"
          loading="lazy" 
        />
      </AspectRatio>

      <Stack mt="md" gap="xs">
        <Group justify="space-between">
          <Text fw={600} size="lg" lineClamp={1}>
            {product.name}
          </Text>
          <Badge size="sm">{product.category?.name || "Category"}</Badge>
        </Group>

        <Text size="sm" c="dimmed" lineClamp={2}>
          {product.shortDescription || "No description"}
        </Text>
      </Stack>
    </Card>
  );
};